<!-- Off-Canvas Category Menu -->
<div class="fixed inset-y-0 left-0 w-72 bg-gray-900 text-white shadow-lg transform transition-transform duration-300 z-50" id="shop-categories">
  <div class="p-4 border-b border-gray-700">
    <h3 class="text-xl font-serif text-gold">Shop Categories</h3>
  </div>
  <nav class="p-4">
    <ul class="space-y-2">
      <li class="has-children">
        <span class="flex items-center justify-between">
          <a href="#" class="text-gray-300 hover:text-gold transition duration-300">Men's Shoes</a>
          <span class="sub-menu-toggle cursor-pointer text-gray-300 hover:text-gold">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </span>
        </span>
        <ul class="offcanvas-submenu pl-4 mt-2 space-y-1">
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">Sneakers</a></li>
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">Loafers</a></li>
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">Boat Shoes</a></li>
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">Sandals</a></li>
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">View All</a></li>
        </ul>
      </li>
      <li class="has-children">
        <span class="flex items-center justify-between">
          <a href="#" class="text-gray-300 hover:text-gold transition duration-300">Women's Shoes</a>
          <span class="sub-menu-toggle cursor-pointer text-gray-300 hover:text-gold">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </span>
        </span>
        <ul class="offcanvas-submenu pl-4 mt-2 space-y-1">
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">Sandals</a></li>
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">Flats</a></li>
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">Sneakers</a></li>
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">Heels</a></li>
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">View All</a></li>
        </ul>
      </li>
      <li class="has-children">
        <span class="flex items-center justify-between">
          <a href="#" class="text-gray-300 hover:text-gold transition duration-300">Men's Clothing</a>
          <span class="sub-menu-toggle cursor-pointer text-gray-300 hover:text-gold">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </span>
        </span>
        <ul class="offcanvas-submenu pl-4 mt-2 space-y-1">
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">Shirts & Tops</a></li>
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">Pants</a></li>
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">Jackets</a></li>
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">View All</a></li>
        </ul>
      </li>
      <li class="has-children">
        <span class="flex items-center justify-between">
          <a href="#" class="text-gray-300 hover:text-gold transition duration-300">Women's Clothing</a>
          <span class="sub-menu-toggle cursor-pointer text-gray-300 hover:text-gold">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </span>
        </span>
        <ul class="offcanvas-submenu pl-4 mt-2 space-y-1">
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">Dresses</a></li>
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">Shirts & Tops</a></li>
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">Shorts</a></li>
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">Swimwear</a></li>
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">View All</a></li>
        </ul>
      </li>
      <li class="has-children">
        <span class="flex items-center justify-between">
          <a href="#" class="text-gray-300 hover:text-gold transition duration-300">Kid's Shoes</a>
          <span class="sub-menu-toggle cursor-pointer text-gray-300 hover:text-gold">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </span>
        </span>
        <ul class="offcanvas-submenu pl-4 mt-2 space-y-1">
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">Boots</a></li>
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">Sandals</a></li>
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">Crib Shoes</a></li>
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">Loafers</a></li>
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">View All</a></li>
        </ul>
      </li>
      <li class="has-children">
        <span class="flex items-center justify-between">
          <a href="#" class="text-gray-300 hover:text-gold transition duration-300">Bags</a>
          <span class="sub-menu-toggle cursor-pointer text-gray-300 hover:text-gold">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </span>
        </span>
        <ul class="offcanvas-submenu pl-4 mt-2 space-y-1">
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">Handbags</a></li>
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">Backpacks</a></li>
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">Luggage</a></li>
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">Wallets</a></li>
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">View All</a></li>
        </ul>
      </li>
      <li class="has-children">
        <span class="flex items-center justify-between">
          <a href="#" class="text-gray-300 hover:text-gold transition duration-300">Accessories</a>
          <span class="sub-menu-toggle cursor-pointer text-gray-300 hover:text-gold">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </span>
        </span>
        <ul class="offcanvas-submenu pl-4 mt-2 space-y-1">
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">Sunglasses</a></li>
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">Hats</a></li>
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">Watches</a></li>
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">Jewelry</a></li>
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">Belts</a></li>
          <li><a href="#" class="block text-gray-400 hover:text-gold transition duration-300">View All</a></li>
        </ul>
      </li>
    </ul>
  </nav>
</div>

<!-- Off-Canvas Mobile Menu -->
<div class="fixed inset-y-0 left-0 w-72 bg-gray-900 text-white shadow-lg transform transition-transform duration-300 z-50" id="mobile-menu" [ngClass]="{'translate-x-0': (offcanvasService.offcanvasNavigationOpen | async), '-translate-x-full': !(offcanvasService.offcanvasNavigationOpen | async)}">
  <div *ngIf="user" class="p-4 border-b border-gray-700">
    <a routerLink="/account/profile" (click)="onNavigationClick()" class="flex items-center space-x-3">
      <div class="user-info">
        <span class="text-sm text-gray-400">Logged in as:</span>
        <h6 class="text-lg font-serif text-gold">{{ user?.email }}
          <span *ngIf="user?.roles?.admin" class="text-gray-400"> (Admin)</span>
        </h6>
      </div>
    </a>
  </div>
  <nav class="p-4">
    <ul class="menu space-y-2">
      <li *ngIf="!user" routerLinkActive="active">
        <span>
          <a routerLink="/register-login" (click)="onNavigationClick()">
            <span class="text-gray-300 hover:text-gold transition duration-300">Register/Login</span>
          </a>
        </span>
      </li>
      <li *ngIf="user" routerLinkActive="active">
        <span>
          <a routerLink="/account/profile" (click)="onNavigationClick()">
            <span class="text-gray-300 hover:text-gold transition duration-300">My Profile</span>
          </a>
        </span>
      </li>
      <li *ngIf="user" routerLinkActive="active">
        <span>
          <a routerLink="/account/orders" (click)="onNavigationClick()">
            <span class="text-gray-300 hover:text-gold transition duration-300">My Orders</span>
          </a>
        </span>
      </li>
      <li routerLinkActive="active">
        <span>
          <a routerLink="/home" (click)="onNavigationClick()">
            <span class="text-gray-300 hover:text-gold transition duration-300">Home</span>
          </a>
        </span>
      </li>
      <li routerLinkActive="active">
        <span>
          <a routerLink="/products" (click)="onNavigationClick()">
            <span class="text-gray-300 hover:text-gold transition duration-300">Products</span>
          </a>
        </span>
      </li>
      <li routerLinkActive="active">
        <span>
          <a routerLink="/cart" (click)="onNavigationClick()">
            <span class="text-gray-300 hover:text-gold transition duration-300">Cart</span>
          </a>
        </span>
      </li>
      <li *ngIf="user && user?.roles?.admin" routerLinkActive="active">
        <a routerLink="/admin/add" (click)="onNavigationClick()">
          <span class="text-gray-300 hover:text-gold transition duration-300">Add Product</span>
        </a>
      </li>
      <li *ngIf="user">
        <a href="" (click)="onLogout($event)">
          <span class="text-gray-300 hover:text-gold transition duration-300">Logout</span>
        </a>
      </li>
    </ul>
  </nav>
</div>
